import { render } from "./SimplifiedCriterion.vue?vue&type=template&id=6124b346&scoped=true"
import script from "./SimplifiedCriterion.vue?vue&type=script&lang=js"
export * from "./SimplifiedCriterion.vue?vue&type=script&lang=js"

import "./SimplifiedCriterion.vue?vue&type=style&index=0&id=6124b346&scoped=true&lang=css"
import "./SimplifiedCriterion.vue?vue&type=style&index=1&id=6124b346&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6124b346"]])

export default __exports__